import React, {useState} from 'react';
import Grid from '@material-ui/core/Grid';
import { TakisSvg } from '../components/TakisSvgs';
import TakisButton from '../components/TakisButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from "@material-ui/core/styles";
import { useStyles } from './TakisSocial.styles';
import TakisVideoModal from './TakisVideoModal';

const TakisSocialVideo = ({network, data}) => {
    const [isOpen, setIsOpen] = useState(false)
    const classes = useStyles();
    const isYT = network === "youtube";
    if(isYT){
        const videoID = data.video_embed;
        return (
            <>
            <TakisVideoModal videoId={videoID} modalState={isOpen} modalFunction={() => setIsOpen(false)}></TakisVideoModal>
            <div className={classes.left_container_bg}>
                <div className={classes.left_container} onClick={()=> setIsOpen(true)}>
                    <img className={classes.thumb} src={data.image} alt="Video thumbnail"></img>
                    <div className={classes.play_div}><TakisSvg icon="play" ariaLabel="Play video" svg_class={classes.play_svg}/></div>
                </div>
                <div className={classes.icon_container}><TakisSvg icon={network} ariaLabel={network} svg_class={classes.social_icon}/></div>
            </div>
            </>
        );
    }
    else{
        return (
            <div className={classes.left_container_bg}>
                <div className={classes.left_container} onClick={()=> window.open(data.video_embed, "_blank")}>
                    <img className={classes.thumb} src={data.image} alt="Video thumbnail"></img>
                    <div className={classes.play_div}><TakisSvg icon="play" ariaLabel="Play video" svg_class={classes.play_svg}/></div>
                </div>
                <div className={classes.icon_container}><TakisSvg icon={network} ariaLabel={network} svg_class={classes.social_icon}/></div>
            </div>
        );
    }
}

const TakisSocialText = ({network, data}) => {
    const classes = useStyles();
    const theme = useTheme();
    const onMobile = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));
    return (
        <div className={classes.right_container}>
            <div className={classes.right_content}>
                <div className={classes.social_details_container}>
                    <div className={`${classes.icon_container} ${classes.unset_icon}`}><TakisSvg icon={network} ariaLabel={network} svg_class={classes.social_icon}/></div>
                    <h3 className={classes.social_details_heading}>{data.social_detail_title}</h3>
                    <p className={classes.social_details_p}>{data.social_detail_content}</p>
                    {!onMobile &&
                        <div className={classes.button_container}>
                            <TakisButton color="yellowPurpleButton" title={data.cta.title} alt={data.cta.alt} href={(data.cta.ariaLabel === "See our page" || data.cta.ariaLabel === "VISITA NUESTRA PÁGINA") ? "https://www.instagram.com/takisusa/?hl=en" : data.cta.href} target="_blank" ariaLabel={data.cta.ariaLabel}/>
                        </div>
                    }
                </div>
                <img className={classes.social_image} src={data.social_detail_image} alt="Social product"></img>
            </div>
            {onMobile &&
                <div className={classes.button_container}>
                    <TakisButton color="yellowPurpleButton" title={data.cta.title} alt={data.cta.alt} href={(data.cta.ariaLabel === "See our page" || data.cta.ariaLabel === "Ver nuestra página") ? "https://www.instagram.com/takisusa/?hl=en" : data.cta.href} target="_blank" ariaLabel={data.cta.ariaLabel}/>
                </div>
            }
            <div className={`${classes.icon_container} ${classes.right_grid_icon}`}><TakisSvg icon={network} ariaLabel={network} svg_class={classes.social_icon}/></div>
        </div>
  );
}

const TakisSocial = ({data}) => {
    const classes = useStyles();
    return (
      <div className={classes.social_container}>
          <h2 className={classes.social_heading} data-aos="fade-up">{data.title}</h2>
          <Grid className={classes.social_grid_container} container spacing={0}>
            <Grid item xs={12} lg={6} data-aos="fade-up">
                <TakisSocialVideo network={data.video_social} data={data.video_type}></TakisSocialVideo>
            </Grid>
            <Grid item xs={12} lg={6} data-aos="fade-up">
                <TakisSocialText network={data.text_social} data={data.text_type}></TakisSocialText>
            </Grid>
        </Grid>
      </div>
  );
}


export default TakisSocial;
